<script>
  import { onMount } from "svelte"
  import { AppsRepository, ContractsRepository } from "../../repositories/index"
  import { _, callout, user } from "../../stores/index"
  import { AssignmentGrid } from "../../components/index"
  import { Loader, Button, FlexItem, Breadcrumb, BreadcrumbItem } from "@gl/design-system"
  import { navigate } from "svelte-routing"

  export let id

  let assignmentGrid

  let allContracts = []
  let assignedContracts = []

  let assignmentGridObj = {
    current: [],
    available: [],
  }

  const loading = {}

  async function fetchContracts() {
    try {
      loading.members = true

      const result = await ContractsRepository.getContracts()
      allContracts = result.list

      const resultApps = await AppsRepository.getContracts(id)
      assignedContracts = resultApps.list
      assignedContracts = assignedContracts.map((c) => {
        let foundContract = allContracts.find((ac) => ac.id === c)
        return {
          id: c,
          name: foundContract?.name,
          customer: { name: foundContract?.customer.name, id: foundContract?.customer.id },
        }
      })
    } finally {
      mapContracts()
      loading.members = false
    }
  }

  function mapContracts() {
    assignmentGridObj = {
      available: [],
      current: [],
    }

    const mapContract = (c) => {
      return {
        id: c?.id,
        label: c?.name,
        info: c?.customer.name,
      }
    }

    const mappedAssignedContracts = assignedContracts.filter((c) => c.id).map(mapContract)
    assignmentGridObj.current.push(...mappedAssignedContracts)

    const mappedAllContracts = allContracts
      .filter((c) => !assignedContracts.some((ac) => ac.id === c.id) && c.id)
      .map(mapContract)
    assignmentGridObj.available.push(...mappedAllContracts)

    assignmentGridObj.current.sort((a, b) => a.label.localeCompare(b.label))
    assignmentGridObj.available.sort((a, b) => a.label.localeCompare(b.label))
  }

  async function handleSave() {
    loading.save = true

    const selected = assignmentGrid.getCurrent()

    const contractsToAdd = selected.all.filter((cID) => !assignedContracts.some((ac) => ac.id === cID))
    const contractsToRemove = assignedContracts.filter((ac) => !selected.all.includes(ac.id)).map((ac) => ac.id)

    if (contractsToAdd.length === 0 && contractsToRemove.length === 0) {
      callout.set({
        msg: $_("no.changes.callout"),
        status: "warning",
        timeout: true,
      })
      loading.save = false
      return null
    }

    try {
      if (contractsToAdd.length) {
        await Promise.all(contractsToAdd.map((c) => ContractsRepository.addApp(c, id)))
      }

      if (contractsToRemove.length) {
        await Promise.all(contractsToRemove.map((c) => ContractsRepository.removeApp(c, id)))
      }

      let calloutMsg = ""
      if (contractsToAdd.length > 0)
        calloutMsg += `${contractsToAdd.length} ${$_("assignment.callout.contracts.added")} `
      if (contractsToRemove.length > 0)
        calloutMsg += `${contractsToRemove.length} ${$_("assignment.callout.contracts.removed")} `

      callout.set({
        msg: calloutMsg,
        status: "success",
        timeout: true,
      })
    } finally {
      fetchContracts()
      loading.save = false
    }
  }

  onMount(() => {
    fetchContracts()
    if (!$user.data.isMaster) navigate("/forbidden")
  })
</script>

{#if loading.members}
  <Loader status="info" />
{:else}
  <AssignmentGrid data={assignmentGridObj} bind:this={assignmentGrid} checkboxes={false} resource="contracts" />

  <div class="footer-buttons py-6">
    <Button on:click={() => assignmentGrid.reset()} outlined>{$_("common.reset")}</Button>
    <FlexItem pushEnd>
      <Button on:click={handleSave} class="mr-3" loading={loading.save}>{$_("buttons.save")}</Button>
      <Button on:click={() => navigate("/access-manager/admin/apps")} outlined>{$_("buttons.cancel")}</Button>
    </FlexItem>
  </div>
{/if}
